import { escapeHtml } from "@sp-crm/core";

interface SanitizedMarkUp {
    __html: string;
}

export const highlightSearchExcerpt = (excerpt: string): SanitizedMarkUp => {
    const escaped = escapeHtml(excerpt);
    const highlighted = escaped.replace(
        /&lt;highlight&gt;(.*?)&lt;\/highlight&gt;/g,
        '<span class="font-bold text-yellow-500">$1</span>',
    );
    return { __html: highlighted };
};
